"use client";

import React from "react";
import { MarketPredictionModal } from "./modals/MarketPredictionModal";
import { useAppStore } from "@/store/useAppStore";
import { liveMarkets } from "@/utils/liveMarkets";
import { useAuth } from "@/hooks/useAuth";

export const LiveMarkets = () => {
  const {
    completedMarkets,
    setSelectedMarket,
    setShowMarketModal,
    setActiveModal,
    setIsModalOpen,
  } = useAppStore();

  const { user } = useAuth();

  const handleMakePrediction = (market: any) => {
    if (!user?.email) {
      setIsModalOpen(true);
      setActiveModal("auth");
    } else {
      setSelectedMarket(market);
      setShowMarketModal(true);
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-5 md:px-8 pt-8 pb-24">
      <h2 className="text-3xl font-bold mb-2 tracking-[-1px]">
        Live Markets
      </h2>
      <p className="text-[#808080] mb-8 text-sm">
        One prediction per market. Choose wisely.
      </p>

      <div className="space-y-3">
        {liveMarkets.map((market) => {
          const hasCompleted = completedMarkets.includes(market.id);
          return (
            <div
              key={market.id}
              className={`rounded-lg p-5 ${
                hasCompleted
                  ? "bg-[#0A1A0A] border border-[#1A3A1A]"
                  : "bg-[#1C1C1E]"
              }`}
            >
              <div className="flex justify-between items-start mb-3">
                <h3 className="text-base font-medium text-white leading-snug pr-4">
                  {market.question}
                </h3>
                {hasCompleted && (
                  <span className="text-green-500 text-sm shrink-0">Done</span>
                )}
              </div>
              <div className="flex items-center gap-4 text-xs text-[#808080] mb-4">
                <span>{market.timeLeft}</span>
                <span>{market.participants.toLocaleString()} players</span>
                <span>Avg: {market.averageGuess}%</span>
              </div>
              <div className="flex items-center justify-between">
                {!hasCompleted ? (
                  <button
                    onClick={() => handleMakePrediction(market)}
                    className="bg-[#CCFF00] hover:opacity-85 text-black h-9 px-5 rounded-full text-sm font-medium transition-opacity cursor-pointer"
                  >
                    Predict
                  </button>
                ) : (
                  <span className="text-sm text-green-500">
                    Prediction submitted
                  </span>
                )}
                {market.yourLastGuess && (
                  <span className="text-sm text-[#808080]">
                    Your guess: {market.yourLastGuess}%
                  </span>
                )}
              </div>
              {market.inspiration && (
                <p className="mt-3 text-xs text-[#4D4A46] italic">
                  {market.inspiration}
                </p>
              )}
            </div>
          );
        })}
      </div>
      <MarketPredictionModal />
    </div>
  );
};
